<div class="cart-status" [class]="styleClass">{{label}}</div>